import Typography from '@mui/material/Typography';
import { alpha, styled } from '@mui/material/styles';
import Stack, { StackProps } from '@mui/material/Stack';
import Button, { buttonClasses } from '@mui/material/Button';
import Iconify from 'src/components/iconify';


const iosDownloadURL = "https://apps.apple.com/sg/app/fitu-sg/id6581486813";
const androidDownloadURL = "https://play.google.com/store/apps/details?id=com.fitu.fe.stg";

const StyledAppStoreButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  padding: '5px 12px',
  color: theme.palette.common.white,
  border: `solid 1px ${alpha(theme.palette.common.black, 0.24)}`,
  background: `linear-gradient(180deg, ${theme.palette.grey[900]} 0%, ${theme.palette.common.black} 100%)`,
  height: theme.spacing(6), 
  [`& .${buttonClasses.startIcon}`]: {
    marginLeft: 0,
  },
}));

export function AppStoreButton({ direction, ...props }) {
  return (
    <Stack direction={direction} flexWrap="nowrap" spacing={2} {...props}>
      <StyledAppStoreButton 
        startIcon={<Iconify icon="ri:apple-fill" width={28}/>}
        href={iosDownloadURL}
        target="_blank"
      >
        <Stack alignItems="flex-start">
          <Typography variant="caption" sx={{ opacity: 0.72 }}>
            Download on the
          </Typography>

          <Typography variant="h6" sx={{ mt: -0.5 }}>
            Apple Store
          </Typography>
        </Stack>
      </StyledAppStoreButton>

      <StyledAppStoreButton 
        startIcon={<Iconify icon="logos:google-play-icon" width={28} />}
        href={androidDownloadURL}
        target="_blank"
      >
        <Stack alignItems="flex-start">
          <Typography variant="caption" sx={{ opacity: 0.72 }}>
            Download from
          </Typography>

          <Typography variant="h6" sx={{ mt: -0.5 }}>
            Google Play
          </Typography>
        </Stack>
      </StyledAppStoreButton>
    </Stack>
  );
}
